// extracted by mini-css-extract-plugin
module.exports = {"iconSecondary":"#9b51e0"};